export default __webpack_public_path__ + "static/media/inter-latin.404ca8da.woff2";